import * as actionTypes from "./actionTypes";
import * as types from "./types";


export const fetchProfileRequest = (params: types.IGetProfileParams): types.IFetchProfileRequest => ({
    type: actionTypes.FETCH_PROFILE_REQUEST,
    params: params
});

export const fetchProfileSuccess = (payload: types.IFetchProfileSuccessPayload): types.FetchProfileSuccess => ({
    type: actionTypes.FETCH_PROFILE_SUCCESS,
    payload
});

export const fetchProfileFailure = (payload: types.IFetchProfileFailurePayload): types.FetchProfileFailure => ({
    type: actionTypes.FETCH_PROFILE_FAILURE,
    payload
});
